/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const PopUpBox = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  padding: 8px;
  border-radius: 4px;

  background-color: #fff;
  box-shadow: 0px 0px 18px 0px rgba(23, 43, 77, 0.08), 0px 8px 24px 0px rgba(23, 43, 77, 0.08);
`;

export const FlexWrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
